module.exports = __webpack_public_path__ + "img/areas3.149ba916.png";